export default __webpack_public_path__ + "static/media/gold@3x.19928ba6.png";